import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc, updateDoc, onSnapshot } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA7bf-_uACBS4n0jhqMxT07Y8GRTPEgIq4",
  authDomain: "duocode-1d51c.firebaseapp.com",
  projectId: "duocode-1d51c",
  storageBucket: "duocode-1d51c.firebasestorage.app",
  messagingSenderId: "326164856533",
  appId: "1:326164856533:web:0620680d7087640d906c5c",
  measurementId: "G-XVX6XRMNDT"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

export { signInWithPopup, signOut, doc, setDoc, getDoc, updateDoc, onSnapshot, onAuthStateChanged };